import type { FeedbackAvailability } from "../../shared/api/types";
import { useSession } from "../../shared/session/session-context";
import { useFeedbackAvailability } from "./api";

export const FEEDBACK_TITLE = "Pin a comment on this screen: a defect or a change request";

/** What the header offers: the environment's feedback project and limits. */
export type FeedbackOffer = FeedbackAvailability & { available: true };

/**
 * Whether Feedback is offered (flag on, not a partner, the environment has a feedback project; ruling 2026-10-01), shared by
 * the header button and the phone account menu (D-B17-03). The menu closes itself before the pin layer opens, so the layer's
 * state lives in the shell, not in the menu.
 */
export function useFeedbackOffer(): FeedbackOffer | null {
  const session = useSession();
  const on = session.flag("PinFeedback") && !session.isPartner;
  const availability = useFeedbackAvailability(on);
  return on && availability.data?.available ? (availability.data as FeedbackOffer) : null;
}
